<script lang="ts">
	import Lazy from 'svelte-lazy';
  import { PUBLIC_BIXOTO_MEDIA } from '$env/static/public';
  import type { GalleryEntry } from "$lib/js/elasticsearch/types";

  export let gallery: GalleryEntry[] = []
  export let showImg = false;
  export let imgIndex = 0;

  let uClass = "closed"
  let btnText = "Ver todas las imágenes"

  /* Images zoom and slider actions */
  function zoomImage(i: number) {
    showImg = true
    imgIndex = i;
  }

  function viewAll() {
    uClass = uClass === "open" ? "closed" : "open"
    btnText = btnText === "Ver todas las imágenes" ? "Ver menos" : "Ver todas las imágenes"
  }
</script>


{#if gallery.length > 1}
  <div class="gallery {uClass}">
    <h2 class="head-4">Galería multimedia</h2>

    <div class="gallery__inner">
      {#each gallery as media, i}
        {#if media.vid}
          <div class="video">
            <Lazy height={400}>
              <iframe
                width="560"
                height="315"
                loading="lazy"
                src="https://www.youtube.com/embed/{media.vid.video_id}"
                title={media.vid.desc}
                style="border:0;"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              >
              </iframe>
            </Lazy>
          </div>
        {:else if media.resized_image}
          <button
            on:click={() => zoomImage(i)}
            class="gallery__img"
            title="Product image {i}"
            aria-label={media.lab}
          >
            <img
              src="{PUBLIC_BIXOTO_MEDIA}{media.resized_image?.path}"
              loading="lazy"
              alt={media.lab}
              title={media.lab}
              width="{media.resized_image.width}"
              height="{media.resized_image.height}"
            >
          </button>
        {/if}
      {/each}
    </div>

    {#if gallery.length > 2}
      <div class="gallery__overlay"></div>
      <button class="gallery__more" on:click={() => viewAll()}>{btnText}</button>
    {/if}
  </div>
{/if}


<style lang="scss">
  .gallery {
    text-align: center;
    margin-top: 50px;
    transition: all linear 0.25s;

    h2 {
      text-align: left;
      margin-bottom: 30px;
    }

    &.closed {
      position: relative;

      .gallery__overlay {
        height: 120px;
        background: linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
        position: absolute;
        bottom: 65px;
        left: 0;
        right: 0;
        pointer-events: none;
      }
    }

    &.open {
      .gallery__inner {
        max-height: 100%;
      }
    }

    &__more {
      margin-top: 30px;
      width: 225px;
      border: 1px solid black;
      border-radius: 5px;
      padding: 6px 15px;
      font-weight: 700;
      text-align: center;
    }

    &__inner {
      max-height: 600px;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      transition: all linear 0.25s;
      padding-bottom: 15px;
    }

    &__img {
      overflow: hidden;
      margin-bottom: 15px;
      order: 1;

      @media (min-width: 769px) {
        width: calc(50% - 10px);
      }

      &:hover {
        img {
          @media (min-width: 769px) {
            transform: scale(1.08);
          }
        }
      }

      img {
        display: flex;
        transition: all linear 0.125s;
        width: 100%;
        height: auto;
      }
    }

    .video {
      order: 0;
      width: 100%;
      height: 400px;
      margin-bottom: 25px;

      iframe {
        width: 100%;
        height: 400px;
      }
    }
  }
</style>
